<template>
    <v-group :config="groupConfig">
        <v-image ref="image" :config="imageConfig"></v-image>
    </v-group>
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        name: "BrushWithColor",

        props: [
            'colorId',
            'color',
            'image',
        ],

        emits: [
            'getCachedImage',
        ],

        computed: {
            ...mapState('paint', [
                'cachedBrushes',
            ]),

            groupConfig() {
                return {
                    x: -1000
                }
            },

            imageConfig() {
                return {
                    image: this.image,
                    // rotation: 45,
                }
            },

        },

        methods: {
            ...mapActions('paint', [
                'saveBrush',
            ]),

            colorFilter(imageData) {
                const color = this.color;
                let nPixels = imageData.data.length;

                for (let i = 0; i < nPixels; i += 4) {
                    imageData.data[i] = color.R;
                    imageData.data[i+1] = color.G;
                    imageData.data[i+2] = color.B;
                    // imageData.data[i+3]     // Alpha
                }

            },

            changeBrushColor() {
                // check if the brush was cached before
                const cachedBrush = this.cachedBrushes[this.colorId];

                if (cachedBrush) {
                    this.$emit('getCachedImage', cachedBrush);

                    return;
                }

                // get access to image node on canvas
                let image = this.$refs.image.getNode();

                // apply filter with paint color
                image.filters([this.colorFilter]);

                // cache image
                image.cache();

                // create <img> tag based on cached image for use it in other components
                let exportImage = image.toDataURL();

                // load cached exported image
                this.$utils.loadImage((img) => {

                    // save cached brush to the store for reuse
                    this.saveBrush({ id: this.colorId, cachedBrush: img });

                    this.$emit('getCachedImage', img);
                }, exportImage);

            },

        },

        watch: {
            colorId() {
                this.changeBrushColor();
            },
        },

        mounted() {
            this.changeBrushColor();
        },

    }
</script>

<style scoped>

</style>